// src/components/UserSideLoader.jsx
import React from "react";
import Lottie from "lottie-react";
import animationData from "../assets/animations/CarInCity.json"; // adjust path

export default function Loader() {
  return (
    <div className="relative flex items-center justify-center h-screen w-full bg-gradient-to-br from-blue-100/40 via-white/40 to-violet-100/40 backdrop-blur-xl">
      {/* Subtle glowing circle behind animation */}
      <div className="absolute w-72 h-72 sm:w-96 sm:h-96 rounded-full bg-blue-200/40 blur-3xl animate-pulse" />

      {/* Animation */}
      <Lottie
        animationData={animationData}
        loop={true}
        className="relative w-40 h-40 sm:w-56 sm:h-56 md:w-72 md:h-72 lg:w-80 lg:h-80 animate-fadeIn"
      />

      {/* Text */}
      <p className="absolute bottom-20 sm:bottom-24 md:bottom-28 text-sm sm:text-base md:text-lg font-semibold text-gray-700 tracking-wide animate-pulse">
        Loading, please wait...
      </p>
    </div>
  );
}
